import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function WorkspacesIcon(props: IconProps) {
    return <Icon {...props} iconKey={"workspaces"}/>
}
